<template>
    <div class="columns is-mobile is-centered has-background-primary p-2" v-if="props.titoloVisibile==true">
        <h1 class="title is-4 has-text-white">CONTATTI</h1>
    </div>

        <div class="columns is-mobile is-centered">
        <div class="column is-5" v-if="props.campoRicercaVisibile==true">
            <input class="input is-primary" type="text" v-model="testoRicerca" placeholder="Cerca..." @keyup.enter="bCerca">
        </div>
        <div class="column is-1 has-text-centered" v-if="props.bottoneAggiungiVisibile==true && !schermoLargo">
            <button class="button is-primary is-outlined" @click="bSelezionaElemento(-1)">
                <span class="icon"><i class="fas fa-plus"></i></span>
            </button>
        </div>
        <div class="column is-1 has-text-centered" v-if="props.bottoneAggiungiVisibile==true && schermoLargo">
            <button class="button is-primary is-outlined" @click="bScaricaContatti()">
                <span class="icon" title="Scarica tutti i contatti"><i class="fas fa-download"></i></span>
            </button>
        </div>
        <div class="column is-1 has-text-centered" v-if="props.bottoneAggiungiVisibile==true && schermoLargo && props.cliente">
            <button class="button is-primary is-outlined" @click="bCreaContattoDaCliente()">
                <span class="icon" title="Crea contatto da cliente"><i class="fas fa-plus"></i><i class="fas fa-user"></i></span>
            </button>
        </div>
    </div>

    <div class="blocco-scroll" v-if="!schermoLargo">
        <div v-if="!schermoLargo && !elencoSospeso && !props.visioneCompatta">
            <div class="box" v-for="(ct) in elencoContatti" :key="leggiInfoDB(ct).id">
                <button class="button is-small is-primary is-outlined" @click="bSelezionaElemento(leggiInfoDB(ct).id)">
                    <span class="icon"><i class="fas fa-arrow-right-from-bracket"></i></span>
                </button>
                <span v-if="ct.tu && credenzialiUtente.autorizzazione=='sviluppatore'">&nbsp; &nbsp;</span>
                <span class="icon has-text-warning" v-if="ct.tu && credenzialiUtente.autorizzazione=='sviluppatore'"> <i class="fas fa-regular fa-face-smile"></i></span>
                &nbsp; {{ nomeContattoCompatto(leggiInfoDB(ct).id) }}
                <div v-if="props.lavoro && !props.visioneCompatta" title="Cambia ruolo"> <a @click="bCambiaRuolo(leggiInfoDB(ct).id)"> {{ dbClienti[props.cliente].lavori[props.lavoro].contatti[leggiInfoDB(ct).id].ruolo }} </a> </div>
                <div v-if="props.lead && !props.visioneCompatta" title="Cambia ruolo"> <a @click="bCambiaRuolo(leggiInfoDB(ct).id)"> {{ dbClienti[props.cliente].leads[props.lead].contatti[leggiInfoDB(ct).id].ruolo }} </a> </div>
                <div v-if="ct.telefono"> Tel: <a :href="linkTelefono(ct.telefono)">{{ct.telefono}}</a> </div>
                <div v-if="ct.telefono2"> Tel: <a :href="linkTelefono(ct.telefono2)">{{ct.telefono2}}</a> </div>
                <div v-if="ct.mail"> Mail: <a :href="linkMail(ct.mail)">{{ct.mail}}</a> </div>
                <div v-if="ct.mail2"> Mail: <a :href="linkMail(ct.mail2)">{{ct.mail2}}</a> </div>
                <div v-if="ct.pec"> PEC: {{ct.pec}} </div>
                <div v-if="ct.note"> Note: {{ct.note}} </div>
                <div v-if="ct.noteMarco && credenzialiUtente.autorizzazione=='sviluppatore'"> Note Marco: {{ct.noteMarco}} </div>
            </div>
            <div>
                &nbsp;  &nbsp; &nbsp; &nbsp; {{stringaNumeroRecord}}
            </div>
        </div>
    </div>

    <div class="blocco-scroll" v-if="(schermoLargo || props.visioneCompatta) && !elencoSospeso">
        <table class="table is-striped mx-auto">
            <thead>
                <tr>
                    <th class="has-text-centered">
                        <button class="button is-small is-primary is-outlined" @click="bSelezionaElemento(-1)" v-if="props.bottoneAggiungiVisibile==true">
                            <span class="icon"><i class="fas fa-plus"></i></span>
                        </button>
                    </th>
                    <th v-if="mostraInfoSviluppo"></th> <th class="has-text-centered" v-if="mostraInfoSviluppo">Id</th>
                    <th class="has-text-centered" title="Rapporto" v-if="!props.visioneCompatta && credenzialiUtente.autorizzazione=='sviluppatore'">R</th> <th v-if="!props.visioneCompatta"></th> <th v-if="!props.visioneCompatta">Nome</th>
                    <th v-if="!props.visioneCompatta">Cognome</th>
                    <th v-if="!props.visioneCompatta">Azienda</th>
                    <th v-if="!props.visioneCompatta">Telefono principale</th>
                    <th v-if="!props.visioneCompatta">Telefono</th>
                    <th v-if="!props.visioneCompatta">Mail principale</th>
                    <th v-if="!props.visioneCompatta">Mail</th>
                    <th v-if="!props.visioneCompatta" class="has-text-centered" title="Note">N</th>
                    <th class="has-text-centered" title="Note Marco" v-if="credenzialiUtente.autorizzazione=='sviluppatore' && !props.visioneCompatta">NM</th>
                    <th v-if="props.cliente && !props.visioneCompatta">Ruolo</th>
                    <th v-if="props.cliente && !props.visioneCompatta">
                        <button class="button is-small is-primary is-outlined" @click="bCopia()">
                            <span class="icon" title="Copia elenco contatti"><i class="fas fa-copy"></i></span>
                        </button>
                    </th>
                    <th v-if="!props.visioneCompatta" class="has-text-right">
                        <button class="button is-small is-primary is-outlined" @click="bIncolla()" :disabled="!('contatti' in copiaTrasporto)" v-if="props.cliente">
                            <span class="icon" title="Incolla elenco contatti"><i class="fas fa-paste"></i></span>
                        </button>
                    </th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(ct, index) in elencoContatti" :key="leggiInfoDB(ct).id">
                    <td class="has-text-centered">
                        <button class="button is-small is-primary is-outlined" @click="bSelezionaElemento(leggiInfoDB(ct).id)">
                            <span class="icon"><i class="fas fa-arrow-right-from-bracket"></i></span>
                        </button>
                    </td>
                    <td class="has-text-centered" v-if="mostraInfoSviluppo">{{index + 1}}</td>
                    <td class="has-text-centered" v-if="mostraInfoSviluppo">{{leggiInfoDB(ct).id}} {{ ct._info ? 'F' : 'C' }}</td>
                    <td class="has-text-centered" v-if="!props.visioneCompatta && credenzialiUtente.autorizzazione=='sviluppatore'">
                        <span class="icon has-text-warning" v-if="ct.tu"><i class="fas fa-regular fa-face-smile"></i></span>
                    </td>
                    <td v-if="!props.visioneCompatta">{{ct.titolo}}</td>
                    <td v-if="!props.visioneCompatta">{{ct.nome}}</td>
                    <td v-if="!props.visioneCompatta">{{ct.cognome}}</td>
                    <td v-if="!props.visioneCompatta">{{ct.azienda}}</td>
                    <td v-if="props.visioneCompatta">{{nomeContattoCompatto(leggiInfoDB(ct).id)}}</td>
                    <td v-if="!props.visioneCompatta"><a :href="linkTelefono(ct.telefono)">{{ct.telefono}}</a></td>
                    <td v-if="!props.visioneCompatta"><a :href="linkTelefono(ct.telefono2)">{{ct.telefono2}}</a></td>
                    <td v-if="!props.visioneCompatta"><a :href="linkMail(ct.mail)">{{ct.mail}}</a></td>
                    <td v-if="!props.visioneCompatta"><a :href="linkMail(ct.mail2)">{{ct.mail2}}</a></td>
                    <td class="has-text-centered" v-if="!props.visioneCompatta">
                        <ComponenteIcona nome="Nota" :visibileSempre="false" :descrizione="ct.note"/>
                    </td>
                    <td class="has-text-centered" v-if="credenzialiUtente.autorizzazione=='sviluppatore' && !props.visioneCompatta">
                        <ComponenteIcona nome="Nota" :visibileSempre="false" :descrizione="ct.noteMarco"/>
                    </td>
                    <td v-if="props.lavoro && !props.visioneCompatta" title="Cambia ruolo"> <a @click="bCambiaRuolo(leggiInfoDB(ct).id)"> {{ dbClienti[props.cliente].lavori[props.lavoro].contatti[leggiInfoDB(ct).id].ruolo }} </a> </td>
                    <td v-if="props.lead && !props.visioneCompatta" title="Cambia ruolo"> <a @click="bCambiaRuolo(leggiInfoDB(ct).id)"> {{ dbClienti[props.cliente].leads[props.lead].contatti[leggiInfoDB(ct).id].ruolo }} </a> </td>
                    <td v-if="(props.lead||props.lavoro) && !props.visioneCompatta">
                        <button class="button is-small is-danger is-outlined" @click="bEliminaElemento(leggiInfoDB(ct).id)">
                            <span class="icon" title="Rimuovi"><i class="fas fa-minus"></i></span>
                        </button>
                    </td>
                    <td class="has-text-right" v-if="!props.visioneCompatta">
                        <button class="button is-small is-primary is-outlined" @click="bScaricaContatti(leggiInfoDB(ct).id)">
                            <span class="icon" title="Scarica contatto"><i class="fas fa-download"></i></span>
                        </button>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td class="has-text-centered" colspan="3">{{stringaNumeroRecord}}</td>
                </tr>
            </tfoot>
        </table>
    </div>

    <MessaggioModale @selezionato="bComandoModale"
        :confMessaggioModale=messaggioModale
        v-if="messaggioModale"/>
    <ElencoContattiModale
        :bottoneAggiungiVisibile=false
        :campoRicercaVisibile=true
        @elementoSelezionato="bCambiaContattoDaModale"
        v-if="mostraElencoContattiModale"/>
</template>

<script setup>
    import MessaggioModale from "./MessaggioModale.vue";
    import ElencoContattiModale from "./ElencoContattiModale.vue";
    import ComponenteIcona from "./ComponenteIcona.vue";
    import { defineProps, defineEmits, computed, ref, nextTick } from "vue";
    import { dataDaTimestamp, mostraInfoSviluppo, copiaTrasporto, schermoLargo, getValorePerOrdinamento } from "./../code/utilita";
    import { credenzialiUtente } from "@/code/firebase";
    import { dbContatti, dbClienti, salvaLavoroInFirestore, salvaLeadInFirestore, eliminaContattoDaLavoroInFirestore, eliminaContattoDaLeadInFirestore, salvaContattoInFirestore, leggiInfoDB, leggiInfoDBRaw, aggiungiInfoDB } from "@/code/gestioneDB";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        cliente: {
            type: Number,
            default: null },
        lead: {
            type: Number,
            default: null },
        lavoro: {
            type: Number,
            default: null },
        testoDaCercare: {
            type: String,
            default: null },
        bottoneAggiungiVisibile: {
            type: Boolean,
            default: false },
        campoRicercaVisibile: {
            type: Boolean,
            default: true },
        titoloVisibile: {
            type: Boolean,
            default: true },
        visioneCompatta: {  // Visualizza i nomi senza telefono e mail per la selezione rapida
            type: Boolean,
            default: false }
    });
    const emit = defineEmits(['elementoSelezionato','statoInterfacciaCambiato','copiaContatti', 'incollaContatti']);

    // VARIABILI DEL COMPONENTE
    const messaggioModale = ref(null);                  // null = Non mostrare il messaggio modale
    const testoRicerca = ref(props.testoDaCercare);
    let contattoInModifica = null;
    const mostraElencoContattiModale = ref(false);    // null = Non mostrare il messaggio modale
    const elencoSospeso = ref(false);                 // Spegne tutto l'elenco durante operazione sul DB
    const JSonHtml = ref('');
    const stringaNumeroRecord = ref("");

    const elencoContatti = computed(()=>{
        let tempElencoContatti = [];
        
        // FIX E TATTICA DRY: Helper per l'estrazione sicura e l'iniezione dell'ID
        const aggiungiAllElenco = (idStr) => {
            const contatto = dbContatti.value[idStr];
            if (contatto) {
                // Forziamo l'iniezione dell'ID nella WeakMap usando la chiave nativa del dizionario.
                // Questo neutralizza il "Masking Bug" dei dati freddi e caldi.
                aggiungiInfoDB(contatto, { id: Number(idStr) });
                tempElencoContatti.push(contatto);
            }
        };

        if (props.cliente!=null && props.lavoro!=null) {
            // Carico solo i contatti del lavoro
            for(const ct in dbClienti.value[props.cliente].lavori[props.lavoro].contatti){
                aggiungiAllElenco(ct);
            }
        } else if (props.cliente!=null && props.lead!=null) {
            // Carico solo i contatti del lead
            for(const ct in dbClienti.value[props.cliente].leads[props.lead].contatti){
                aggiungiAllElenco(ct);
            }
        } else {
            // Carico tutti i contatti
            for(const ct in dbContatti.value){
                aggiungiAllElenco(ct);
            }
        }
        
        ordinaElencoElementi(tempElencoContatti);
        filtraElencoElementi(tempElencoContatti, props.testoDaCercare, ['titolo', 'cognome', 'nome', 'azienda', 'note', 'noteMarco', 'telefono', 'telefono2', 'mail', 'mail2'], 25);
        return tempElencoContatti;
    });

    // SETUP DEL COMPONENTE

    // FUNZIONI DEL COMPONENTE

    function bCerca() {
        emit('statoInterfacciaCambiato', {testoRicercaContatti: testoRicerca.value});
    }

    function bSelezionaElemento(idCt) {
        if (idCt==-1 && props.cliente) {
            mostraElencoContattiModale.value = true;
        } else {
            emit('elementoSelezionato', {
                tipo: 'contatto',
                idContatto: idCt
            });
        }
    }

function bCreaContattoDaCliente() {
        if (!props.cliente) return;
        
        const cliente = dbClienti.value[props.cliente];
        if (!cliente) return;

        const nomeCl = (cliente.nome || '').trim().toLowerCase();
        const cognomeCl = (cliente.cognome || '').trim().toLowerCase();

        if (!nomeCl && !cognomeCl) {
            messaggioModale.value = {
                testoLight: { testo: 'Ok', comando: 'annulla' },
                messaggio: "Il cliente non ha nome e cognome definiti in anagrafica."
            };
            return;
        }

        // 1. Verifica se esiste già
        let contattoEsistente = false;
        for (const idCt in dbContatti.value) {
            const ct = dbContatti.value[idCt];
            const nomeCt = (ct.nome || '').trim().toLowerCase();
            const cognomeCt = (ct.cognome || '').trim().toLowerCase();

            if (nomeCl === nomeCt && cognomeCl === cognomeCt) {
                contattoEsistente = true;
                break;
            }
        }

        // 2. Se esiste, avvisa e offri la scelta
        if (contattoEsistente) {
            messaggioModale.value = {
                testoLight: { testo: 'Annulla', comando: 'annulla' },
                testoPrimary: { testo: 'Crea nuovo contatto', comando: 'forzaCreazioneContattoDaCliente' },
                messaggio: `Attenzione: Esiste già un contatto in rubrica con il nome ${cliente.nome || ''} ${cliente.cognome || ''}. Vuoi procedere comunque creandone uno nuovo?`
            };
            return;
        }

        // 3. Se non esiste, procedi direttamente chiedendo il ruolo
        messaggioModale.value = {
            testoLight: { testo: 'Annulla', comando: 'annulla' },
            testoPrimary: { testo: 'Crea e Inserisci', comando: 'salvaNuovoContattoDaCliente' },
            testoDanger: null,
            messaggio: `Crea il contatto ${cliente.nome || ''} ${cliente.cognome || ''} e inserisci il suo ruolo nel contesto:`,
            casellaTestoVisibile: true
        };
    }

    function ordinaElencoElementi(elenco) {
        elenco.sort((a, b) => {
            const aziendaA = getValorePerOrdinamento(a, 'azienda', false) || '';
            const aziendaB = getValorePerOrdinamento(b, 'azienda', false) || '';

            if (aziendaA < aziendaB) return -1;
            if (aziendaA > aziendaB) return 1;

            const cognomeA = getValorePerOrdinamento(a, 'cognome', false) || '';
            const cognomeB = getValorePerOrdinamento(b, 'cognome', false) || '';

            if (cognomeA < cognomeB) return -1;
            if (cognomeA > cognomeB) return 1;

            return 0;
        });

        return elenco;
    }

    function filtraElencoElementi(elencoEl, testo, campi, numeroMax) {
        const tempStringaNumeroRecord = elencoEl.length;
        let elencoTesti = [];
        if (testo) elencoTesti = testo.split('+');
        for (let j=0; j < elencoTesti.length; j++) {
            if ( elencoTesti[j] && (elencoTesti[j]!="") ) {
                let regexCerca;
                try {
                    regexCerca = new RegExp(elencoTesti[j], 'i');
                } catch (exception) {
                    console.log(exception);
                }
                for (let i=0; i < elencoEl.length; i++) {
                    let temp = null;
                    let pos = -1;
                    for (const cc in campi) {
                        if (pos == -1) {
                            if ( Array.isArray(campi[cc]) ) {
                                temp = elencoEl[i][campi[cc][0]][campi[cc][1]];
                            } else if ( campi[cc] == 'anno' ) {
                                temp = dataDaTimestamp(elencoEl[i].data, 'anno');
                            } else {
                                temp = elencoEl[i][campi[cc]];
                            }
                            pos = String(temp).search(regexCerca);
                        }
                    }
                    if (pos == -1) {
                        elencoEl.splice(i,1);
                        i--;
                    }
                }
            }
        }
        if (numeroMax!=null){
            if (elencoEl.length>(numeroMax+5)){
                elencoEl.splice(numeroMax,(elencoEl.length-numeroMax));
            }
        }
        stringaNumeroRecord.value = elencoEl.length + " di " + tempStringaNumeroRecord;
    }

    function linkTelefono(tel) {
        return 'tel:' + tel;
    }

    function linkMail(mail) {
        return 'mailto:' + mail;
    }

    function bCambiaRuolo(idElemento) {
        contattoInModifica = idElemento;
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:{testo:'Cambia', comando:'salvaRuolo'},
            testoDanger:null,
            messaggio:"Cambia il ruolo di " + dbContatti.value[idElemento].nome + ' ' + dbContatti.value[idElemento].cognome + ' nel contesto',
            casellaTestoVisibile:true
        };
    }

    function nomeContattoCompatto(idElemento) {
        let tempNome = '';
        tempNome += dbContatti.value[idElemento].titolo? (dbContatti.value[idElemento].titolo + ' '): '';
        tempNome += dbContatti.value[idElemento].nome? (dbContatti.value[idElemento].nome + ' '): '';
        tempNome += dbContatti.value[idElemento].cognome? (dbContatti.value[idElemento].cognome + ' '): '';
        tempNome += dbContatti.value[idElemento].azienda? ('(' + dbContatti.value[idElemento].azienda + ')'): '';
        return tempNome;
    }

    async function bEliminaElemento(idElemento) {
        contattoInModifica = idElemento;
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:null,
            testoDanger:{testo:'Elimina', comando:'elimina'},
            messaggio:"Elimina " + dbContatti.value[idElemento].nome || '' + ' ' + dbContatti.value[idElemento].cognome || '' + ' dai contatti nel contesto'
        };
    }

    async function bComandoModale(comando, contenuto) {
        let elementoDaAggiornare = {};
        switch (comando) {
            case 'annulla':
                messaggioModale.value = null;
                contattoInModifica = null;
                break;
            case 'salvaRuolo':
                if (contenuto) {
                    if (props.lavoro!=null) {
                        aggiungiInfoDB(elementoDaAggiornare, {
                            id: props.lavoro,
                            idCliente: props.cliente
                        });
                    } else if (props.lead!=null){
                        aggiungiInfoDB(elementoDaAggiornare, {
                            id: props.lead,
                            idCliente: props.cliente
                        });
                    }
                    
                    elementoDaAggiornare.contatti = {};
                    elementoDaAggiornare.contatti[contattoInModifica] = {}
                    elementoDaAggiornare.contatti[contattoInModifica].ruolo = contenuto;
                    
                    messaggioModale.value = null;
                    elencoSospeso.value = true;
                    
                    if (props.lavoro!=null) {
                        await salvaLavoroInFirestore(elementoDaAggiornare);
                    } else if (props.lead!=null){
                        await salvaLeadInFirestore(elementoDaAggiornare);
                    }
                    
                    await nextTick();
                    elencoSospeso.value = false;
                    messaggioModale.value = null;
                    contattoInModifica = null;
                } else {
                    messaggioModale.value = {
                        testoLight:{testo:'Annulla', comando:'annulla'},
                        testoPrimary:{testo:'Inserisci', comando:'salvaRuolo'},
                        testoDanger:null,
                        messaggio:"E' necessario inserire il ruolo di " + dbContatti.value[contattoInModifica].nome + ' ' + dbContatti.value[contattoInModifica].cognome + ' nel contesto',
                        casellaTestoVisibile:true
                    };
                }
                break;
            case 'forzaCreazioneContattoDaCliente': {
                const cliente = dbClienti.value[props.cliente];
                messaggioModale.value = {
                    testoLight: { testo: 'Annulla', comando: 'annulla' },
                    testoPrimary: { testo: 'Crea e Inserisci', comando: 'salvaNuovoContattoDaCliente' },
                    testoDanger: null,
                    messaggio: `Crea il contatto ${cliente.nome || ''} ${cliente.cognome || ''} e inserisci il suo ruolo nel contesto:`,
                    casellaTestoVisibile: true
                };
                break;
            }
            case 'salvaNuovoContattoDaCliente':
                if (contenuto) {
                    const cliente = dbClienti.value[props.cliente];
                    let nuovoContatto = {
                        nome: cliente.nome || '',
                        cognome: cliente.cognome || ''
                    };
                    
                    messaggioModale.value = null;
                    elencoSospeso.value = true;
                    
                    // 1. Salva il nuovo contatto su Firestore (generando ID)
                    await salvaContattoInFirestore(nuovoContatto);
                    const nuovoIdContatto = leggiInfoDBRaw(nuovoContatto).id;

                    // 2. Associa il nuovo contatto al contesto Lavoro o Lead
                    if (props.lavoro != null) {
                        aggiungiInfoDB(elementoDaAggiornare, { id: props.lavoro, idCliente: props.cliente });
                    } else if (props.lead != null){
                        aggiungiInfoDB(elementoDaAggiornare, { id: props.lead, idCliente: props.cliente });
                    }
                    
                    elementoDaAggiornare.contatti = {};
                    elementoDaAggiornare.contatti[nuovoIdContatto] = { ruolo: contenuto };
                    
                    if (props.lavoro != null) {
                        await salvaLavoroInFirestore(elementoDaAggiornare);
                    } else if (props.lead != null){
                        await salvaLeadInFirestore(elementoDaAggiornare);
                    }
                    
                    await nextTick();
                    elencoSospeso.value = false;
                    
                } else {
                    const cliente = dbClienti.value[props.cliente];
                    messaggioModale.value = {
                        testoLight:{testo:'Annulla', comando:'annulla'},
                        testoPrimary:{testo:'Inserisci', comando:'salvaNuovoContattoDaCliente'},
                        testoDanger:null,
                        messaggio:`E' necessario inserire il ruolo per ${cliente.nome || ''} ${cliente.cognome || ''} nel contesto`,
                        casellaTestoVisibile:true
                    };
                }
                break;
            case 'elimina':
                if (props.lavoro!=null) {
                    eliminaContattoDaLavoroInFirestore(props.cliente, props.lavoro, contattoInModifica);
                } else if (props.lead!=null){
                    eliminaContattoDaLeadInFirestore(props.cliente, props.lead, contattoInModifica);
                }
                messaggioModale.value = null;
                contattoInModifica = null;
        }
    }

    function bCambiaContattoDaModale(contatto) {
        contattoInModifica = contatto.idContatto;
        mostraElencoContattiModale.value = false;
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:{testo:'Inserisci', comando:'salvaRuolo'},
            testoDanger:null,
            messaggio:"Inserisci il ruolo di " + dbContatti.value[contattoInModifica].nome || '' + ' ' + dbContatti.value[contattoInModifica].cognome || '' + ' nel contesto',
            casellaTestoVisibile:true
        };
    }

    function bScaricaContatti(idContatto) {
        let stringaContatti = 'given_name,family_name,title,company,phone_number,phone_number,email,email';
        let tempElencoContatti = [];
        if (idContatto!=null) {
            tempElencoContatti.push(dbContatti.value[idContatto]);
        } else {
            if (props.cliente!=null && props.lavoro!=null) {
                // Carico solo i contatti del lavoro
                for(const ct in dbClienti.value[props.cliente].lavori[props.lavoro].contatti){
                    tempElencoContatti.push(dbContatti.value[ct]);
                }
            } else if (props.cliente!=null && props.lead!=null) {
                // Carico solo i contatti del lead
                for(const ct in dbClienti.value[props.cliente].leads[props.lead].contatti){
                    tempElencoContatti.push(dbContatti.value[ct]);
                }
            } else {
                // Carico tutti i contatti
                for(const ct in dbContatti.value){
                    tempElencoContatti.push(dbContatti.value[ct]);
                }
            }

            filtraElencoElementi(tempElencoContatti, props.testoDaCercare, ['titolo', 'cognome', 'nome', 'azienda', 'note', 'noteMarco', 'telefono', 'telefono2', 'mail', 'mail2'], null);
        }
        for (const ct in tempElencoContatti) {
            stringaContatti += '\r\n';
            stringaContatti += tempElencoContatti[ct].nome?tempElencoContatti[ct].nome:'';
            stringaContatti += ',';
            stringaContatti += tempElencoContatti[ct].cognome?tempElencoContatti[ct].cognome:'';
            stringaContatti += ',';
            stringaContatti += tempElencoContatti[ct].titolo?tempElencoContatti[ct].titolo:'';
            stringaContatti += ',';
            stringaContatti += tempElencoContatti[ct].azienda?tempElencoContatti[ct].azienda:'';
            stringaContatti += ',';
            stringaContatti += tempElencoContatti[ct].telefono?tempElencoContatti[ct].telefono:'';
            stringaContatti += ',';
            stringaContatti += tempElencoContatti[ct].telefono2?tempElencoContatti[ct].telefono2:'';
            stringaContatti += ',';
            stringaContatti += tempElencoContatti[ct].mail?tempElencoContatti[ct].mail:'';
            stringaContatti += ',';
            stringaContatti += tempElencoContatti[ct].mail2?tempElencoContatti[ct].mail2:'';
            stringaContatti += ',';
        }
        let tempBlob = new Blob([stringaContatti], {type: "application/octet-stream"});
        let readerB = new FileReader();
        readerB.onload = function(event) {
        var URL = event.target.result;
        JSonHtml.value = URL;
        };
        readerB.readAsDataURL(tempBlob);
        let tempNomeFile;
        if (idContatto!=null) {
            tempNomeFile = dbContatti.value[idContatto].nome?dbContatti.value[idContatto].nome:'';
            tempNomeFile += dbContatti.value[idContatto].cognome?dbContatti.value[idContatto].cognome:'';
            tempNomeFile += dbContatti.value[idContatto].azienda?dbContatti.value[idContatto].azienda:'';
        } else {
            tempNomeFile = 'Contatti';
        }
        tempNomeFile += '.csv';
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:null,
            testoDanger:null,
            messaggio:'Scarica il contatto in formato csv',
            download:{link:JSonHtml, nomeFile:tempNomeFile, comando:'annulla'}
        };
    }

    function bCopia() {
        emit('copiaContatti');
    }

    function bIncolla() {
        emit('incollaContatti');
    }

</script>

<style>
    .table th.prima-riga {
        border: none;
    }
    .table th.bordi-laterali {
        border-left: 1px solid #dbdbdb;
        border-right: 1px solid #dbdbdb;
        /* border-width: 0 0 1px; */
    }
</style>